import { render } from "./App.vue?vue&type=template&id=7b27eef6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7b27eef6&lang=less"

import exportComponent from "/data/gitlab/pay.klicklpay.com/KlicklPaymentPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__